import { useEffect } from "react";

const APP_NAME = "Brocoly Partner";

/** "Anna's Kitchen · Brocoly Partner" in the browser tab and history (nothing while the name is loading). */
export function useDocumentTitle(title: string | undefined) {
  useEffect(() => {
    document.title = title ? `${title} · ${APP_NAME}` : APP_NAME;
    return () => {
      document.title = APP_NAME;
    };
  }, [title]);
}
